import i18next from 'i18next';

// Define the interface for our message structure
interface Message {
  role: 'user' | 'assistant' | 'system';
  content: string;
}

export async function generateClaudeResponse(messages: Message[], availableSlots?: any[]) {
  try {
    const currentLanguage = i18next.language;
    const isItalian = currentLanguage.startsWith('it');

    // Default system prompt (Victor AI)
    let systemPrompt = isItalian
      ? `Sei l'**Assistente di Victor Lazari** (Consulente Informatico, Codice ATECO 62.02.00).
Il tuo ruolo è tecnico e operativo: guidi le aziende verso l'efficienza attraverso sistemi digitali integrati (Launch, Vector).
Non sei un "guru del marketing". Sei un architetto di sistemi.
Parla di: Automazione processi, integrazione CRM, flussi di lavoro, infrastruttura digitale, efficienza operativa.
Evita: Gergo da marketing aggressivo, promesse di guadagno facile, linguaggio da "hacker".
Tono: Professionale, preciso, competente, risolutivo.
Risposte: Conciso, diretto al punto.`
      : `You are **Victor Lazari's Assistant** (IT Consultant).
Your role is technical and operational: guiding companies towards efficiency through integrated digital systems (Launch, Vector).
You are not a "marketing guru". You are a systems architect.
Talk about: Process automation, CRM integration, workflows, digital infrastructure, operational efficiency.
Avoid: Aggressive marketing jargon, "get rich quick" promises, "hacker" slang.
Tone: Professional, precise, competent, solution-oriented.
Output: Concise, straight to the point.`;

    // Inject availability if provided
    if (availableSlots && availableSlots.length > 0) {
      const slotsContext = availableSlots.map(s => ({
        start: s.start_at,
        end: s.end_at
      }));
      
      systemPrompt += isItalian 
        ? `\n\nDISPONIBILITÀ APPUNTAMENTI (Usa questi dati SE l'utente chiede di prenotare):
${JSON.stringify(slotsContext)}
Se l'utente vuole fissare un appuntamento, RISPONDI ESCLUSIVAMENTE IN FORMATO JSON con questa struttura:
{
  "message": "Testo della risposta...",
  "slots": [ ...array degli slot proposti... ],
  "options": ["Non questa settimana", "Altre opzioni..."]
}`
        : `\n\nAPPOINTMENT AVAILABILITY (Use this data IF user asks to book):
${JSON.stringify(slotsContext)}
If user wants to schedule, RESPOND EXCLUSIVELY IN JSON format with this structure:
{
  "message": "Response text...",
  "slots": [ ...array of suggested slots... ],
  "options": ["Not this week", "Other options..."]
}`;
    }

    // Check if a specific system prompt is passed in the messages
    const explicitSystemMsg = messages.find((m) => m.role === 'system');
    if (explicitSystemMsg) {
      systemPrompt = explicitSystemMsg.content;
    }

    // Filter out system message from the array we send to the API (as it goes in 'system' field)
    const apiMessages = messages.filter((m) => m.role !== 'system');

    // Call server proxy to Claude using VITE_CLAUDE_API_KEY on server side
    const resp = await fetch('/api/ai/claude', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        system: systemPrompt,
        messages: apiMessages,
        language: isItalian ? 'it' : 'en'
      })
    });
    const data = await resp.json();
    if (!resp.ok) throw new Error(data?.message || 'Claude proxy error');
    
    const content = data?.content || '';
    
    // Try to parse JSON if the response contains structured data (only for legacy Victor AI prompt)
    if (!explicitSystemMsg) {
    try {
      const parsed = JSON.parse(content);
        // Check for slots or options
        if (parsed.message && (Array.isArray(parsed.options) || Array.isArray(parsed.slots))) {
        return JSON.stringify(parsed);
      }
    } catch {
      // Not JSON, return as plain text
      }
    }
    
    return content;

  } catch (error) {
    console.error('Claude API error:', error);
    const isItalian = i18next.language.startsWith('it');
    return isItalian 
      ? "Mi dispiace, si è verificato un errore. Per favore, riprova più tardi."
      : "I'm sorry, an error occurred. Please try again later.";
  }
} 
